export const TRACKER_BROADCAST_CHANNEL = "tracker:v2:sync";

export const TRACKER_STORAGE_KEYS = {
  draft: "tracker:draft:v2",
  reminderDelivery: "tracker:reminder-delivery:v2",
  memberSelection: "tracker:selection:member:v2",
  providerSelection: "tracker:selection:provider:v2",
  loaPrefill: "tracker:loa:prefill:v2",
  loaResult: "tracker:loa:result:v2",
};

export const TRACKER_SELECTION_EVENT = "tracker:selection-updated";

export const TRACKER_SELECT_QUERY_KEY = "select_for";
export const TRACKER_SELECT_QUERY_VALUE = "tracker";

const safeWindow = typeof window !== "undefined" ? window : null;

export function readStorageObject(key) {
  if (!safeWindow) return null;
  try {
    const raw = safeWindow.localStorage.getItem(key);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
}

export function writeStorageObject(key, payload) {
  if (!safeWindow) return null;
  const envelope = {
    at: Date.now(),
    ...payload,
  };
  safeWindow.localStorage.setItem(key, JSON.stringify(envelope));
  safeWindow.dispatchEvent(
    new CustomEvent(TRACKER_SELECTION_EVENT, {
      detail: { key, payload: envelope },
    })
  );
  return envelope;
}

export function publishTrackerMemberSelection(payload) {
  return writeStorageObject(TRACKER_STORAGE_KEYS.memberSelection, { payload });
}

export function publishTrackerProviderSelection(payload) {
  return writeStorageObject(TRACKER_STORAGE_KEYS.providerSelection, { payload });
}

export function publishTrackerLoaPrefill(payload) {
  return writeStorageObject(TRACKER_STORAGE_KEYS.loaPrefill, { payload });
}

export function publishTrackerLoaResult(payload) {
  return writeStorageObject(TRACKER_STORAGE_KEYS.loaResult, { payload });
}

export function parseTrackerTimeParts(value) {
  if (!value) {
    return { hour: "", minute: "", ampm: "" };
  }

  const date = new Date(value);
  if (!Number.isNaN(date.getTime())) {
    const rawHour = date.getHours();
    const hour = rawHour % 12 || 12;
    const minute = `${date.getMinutes()}`.padStart(2, "0");
    return {
      hour: `${hour}`,
      minute,
      ampm: rawHour >= 12 ? "PM" : "AM",
    };
  }

  const match = String(value).match(/(\d{1,2}):(\d{1,2})(?::\d{1,2})?\s*(AM|PM)?/i);
  if (!match) {
    return { hour: "", minute: "", ampm: "" };
  }

  let hour = Number(match[1]);
  const minute = `${Number(match[2])}`.padStart(2, "0");
  let ampm = (match[3] || "").toUpperCase();

  if (!ampm) {
    ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
  }

  return {
    hour: `${hour}`,
    minute,
    ampm,
  };
}

export function normalizeTrackerSource(value) {
  return String(value || "").trim().toLowerCase();
}

export function sourceNeedsAttachment(value) {
  const source = normalizeTrackerSource(value);
  return source === "email" || source === "viber";
}

export const TRACKER_SOURCE_OPTIONS = [
  "Phone Call",
  "Mobile App",
  "Email",
  "Provider Access",
  "Viber",
  "Mobile Phone",
  "FB Messenger",
  "Provider",
  "Provider QR",
  "Walkin",
  "Others",
];

export const TRACKER_CALL_TYPE_OPTIONS = [
  "Request for Assistance, Benefit/Account Inquiry",
  "Admission Report",
  "Admission VOC",
  "Discharge Report",
  "Discharge Verification",
  "Approval Request",
  "Payment Inquiry",
  "Accreditation",
  "ATAccess",
  "Disapproved",
  "Amendment",
];

export const TRACKER_COVERAGE_OPTIONS = [
  "APE",
  "ATACCESS",
  "MEDPADALA",
  "OUTPATIENT-BASIC-CONSULTATION",
  "OUTPATIENT-CLINIC-SETTING",
  "OUTPATIENT-FACILITY-FEE",
  "OUTPATIENT-LABORATORY",
  "OUTPATIENT-OPD-OR",
  "OUTPATIENT-REFERRAL-TO-SPECIALIST",
  "EMERGENCY",
  "INPATIENT-ADMISSION",
  "INPATIENT-DISCHARGE",
  "MATERNITY-ADMISSION",
  "MATERNITY-BASIC-CONSULTATION",
  "MATERNITY-LABORATORY",
  "MATERNITY-DISCHARGE",
];

export const TRACKER_VALID_ID_OPTIONS = [
  "AMAPHIL Card",
  "Government ID",
  "Driver's License",
];
